import UserPassport from './UserPassport';

export default UserPassport;
